<template>
  <div class="interviewPopup">
      <div class="center">
        <div class="top">
          <p>{{this.$moment().format('YYYY年MM月DD日')}}</p>
          <p>{{this.$moment().format('HH:mm:ss')}}</p>
          <!-- <p style="font-size: 18px;margin-top: 10px">
            第<span>{{number+1}}</span>次访谈
          </p> -->
        </div>
        <div class="middle">
          <p>访谈主题</p>
          <div style="width: 375px;margin:10px auto">
            <el-input placeholder="请输入本次咨询主题" v-if="this.hadInput"></el-input>
            <el-input :value="interView[0].interViewTheme" readonly v-if="!this.hadInput"></el-input>
          </div>

        </div>



        
        <ul class="bottom">
          <li @click="$router.go(-1)">返回</li>
          <li @click="add">开始</li>
        </ul>
        <div class="close" @click="$router.go(-1)">
        </div>
      </div>
  </div>
</template>
<script>
import Button from './Button'
export default {
  name: "InterviewPopup",
  props:['interView','hadInput','getPopupBool','getChildData','getPopupData','query','status'],
  components:{Button},
  data(){
    return{
      interviewTime:null,
      number:0,
      interviewTheme:this.interView[0].interViewTheme,
      category:this.interView[0].category,
    }
  },
  created(){
    console.log(this.query)
  },
  mounted(){
  },
  methods:{
    getData() {
      if(this.hadInput){
        this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.consultationRecord.getParentInterviewNum, {
          studentId: sessionStorage.getItem('myStudentStudentId'),
        }, {
          headers: {
            token: sessionStorage.getItem('ymtxToken')
          }
        }).then(res => {
          if (res.data.code == 2000) {
            this.number=res.data.data.num;
            this.interviewTime=this.$moment().format('YYYY-MM-DD HH:mm:ss')
          } else {
          }
        })
      }else{
        this.$ajax.post(this.G_acapi + this.ports.consultant.student.interView.number, {
          studentId: sessionStorage.getItem('myStudentStudentId'),
        }, {
          headers: {
            token: sessionStorage.getItem('ymtxToken')
          }
        }).then(res => {
          if (res.data.code == 2000) {
            this.number=res.data.data.num;
            this.interviewTime=this.$moment().format('YYYY-MM-DD HH:mm:ss')
          } else {
          }
        })
      }
    },
    add(){
      if(this.hadInput){
        if(!this.interviewTheme){
          this.$message.error('请输入访谈主题')
          return
        }
      }
      
      if(this.getChildData){

        this.getPopupData({
          studentId: sessionStorage.getItem('myStudentStudentId'),
          interviewTime: this.interviewTime,
          interviewNum: this.number + 1,
          category: this.category,
          interviewTheme: this.interviewTheme
        })
        this.getPopupBool(false)
        return;
      }
      this.$ajax.post(this.G_acapi + this.ports.consultant.student.interView.add, {
        studentId:sessionStorage.getItem('myStudentStudentId'),
        interviewTime: this.interviewTime,
        interviewNum: this.number + 1,
        category: this.category,
        interviewTheme: this.interviewTheme
      }, {
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then(res => {
        if (res.data.code == 2000) {
          this.getPopupBool(false)
        } else {
        }
      })
      this.$router.push({path:'/consultant/newstudent/main/firstInterviewPartA',query:{...this.query}})
    },
  },
  mounted(){
    this.getData();
  }
}
</script>

<style scoped lang="less">
.interviewPopup{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.2);
  z-index: 1000;
  .center{
    width: 482px;
    height: 623px;
    position: absolute;
    left: 50%;
    margin-left:-241px;
    top: 50%;
    margin-top: -312px;
    background: url("~@img/xueyezixun/components/interviewPopup/bg.png") center center;
    .top{
      width: 232px;
      margin: 110px auto 0;
      p{
        text-align: center;
        font-size: 16px;
        &:last-child{
          letter-spacing: 1.5px;
          span{
            font-weight: bolder;
            color:#22A1EC;
            margin: 4px;
            font-size: 18px;
          }
        }
      }
    }
    .middle{
      p{
        text-align: center;
        font-weight: bolder;
        font-size: 20px;
        color:#0095EB;
        margin-top:130px;
        letter-spacing: 1.5px;
      }
    }
    .bottom{
      width: 288px;
      height: 3fa2px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      margin-top: 30px;
      li{
        width: 120px;
        height: 100%;
        border-radius: 16px;
        text-align: center;
        line-height: 32px;
        font-size: 16px;
        cursor: pointer;
        background:#ECF8FE;
        color:#1EA2EE;
        border:1px solid #76C6F4;
        &:hover{
          background:#099BEF;
          color:#fff
        }
      }
    }
    .close{
      width: 50px;
      height: 50px;
      border-radius: 50%;
      cursor: pointer;
      position: absolute;
      bottom: 20px;
      left:50%;
      margin-left: -25px;
    }
  }
}
</style>
<style lang="less">
  .interviewPopup{
    .el-input__inner{
      border:1px solid #d9d9d9;
      line-height: 32px;
      height: 32px;
    }
  }
</style>